function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M227.84,4,184.91,58.38h28.62V94.29a87.83,87.83,0,0,1,12.72,45.66V58.38h3.18V211.45h12.72V58.38h28.62Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M213.53,211.45h12.72v-71.5a87.83,87.83,0,0,1-12.72,45.66Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M62.47,75.55H49.75v64.4A87.83,87.83,0,0,1,62.47,94.29Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M62.47,185.61a87.83,87.83,0,0,1-12.72-45.66v88.67H46.57V75.55H33.85V228.62H5.23L48.16,283l42.93-54.38H62.47Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M138,61.74a77.86,77.86,0,1,0,77.86,77.86A77.86,77.86,0,0,0,138,61.74ZM143.18,176v5.64H131.54V176c-10.22-1.77-15.39-8.51-15.39-19v-5.31H129.6v6.08c0,5.53,2.84,7.52,7.37,7.52s7.37-2,7.37-7.52-2.59-9.5-12.16-15.92c-11.64-7.85-15.65-14-15.65-22.88,0-10.39,5-17,15-18.9V94.33h11.64v5.75c10.09,1.77,15.26,8.4,15.26,18.9v2.43H145V118.2c0-5.53-2.59-7.63-7.11-7.63s-7.11,2.1-7.11,7.63,2.59,9.39,12.16,15.92c11.64,8,15.65,14,15.65,22.88C158.56,167.5,153.26,174.24,143.18,176Z"
});

var SvgBudget = function SvgBudget(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 276 287",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBudget, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/budget.7c6d29a4.svg";
export { ForwardRef as ReactComponent };